import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import authentification from './modules/authentification'
import langage from './modules/langage'
import sondage from './modules/sondage'
import popup from './modules/popup'
import question from './modules/question'
import client from './modules/client'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    authentification: {
      userToken: state.authentification.userToken,
      initSearch: state.authentification.initSearch,
      connectUserID: state.authentification.connectUserID,
      connectUserEmail: state.authentification.connectUserEmail,
      isLogged: state.authentification.isLogged,
      idEntreprise: state.authentification.idEntreprise,
      idPlateforme: state.authentification.idPlateforme,
      iframeColidee: state.authentification.iframeColidee,
      authorizedPreview: state.authentification.authorizedPreview
    },
    langage: {
      langue: state.langage.langue
    },
    sondage: {
      configure_questions_sondage: state.sondage.configure_questions_sondage,
      configure_questions_sondage_name: state.sondage.configure_questions_sondage_name,
      sondage_repondu: state.sondage.sondage_repondu
    }
  })
})

Vue.use(Vuex)

export default window.store = new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    authentification,
    langage,
    sondage,
    popup,
    question,
    client
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js